import { render } from "./Facet.vue?vue&type=template&id=594f5dd8&scoped=true&ts=true"
import script from "./Facet.vue?vue&type=script&lang=ts"
export * from "./Facet.vue?vue&type=script&lang=ts"

import "./Facet.vue?vue&type=style&index=0&id=594f5dd8&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594f5dd8"]])

export default __exports__